const _excluded = ["onBlur"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { nonNegativeNumberValidation } from 'validators';
import { InfoIcon, TextField } from 'seagull';
import { positiveQuantityInputProps } from "../../../constants";
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
export default function PreapprovedTextField() {
  const {
    control,
    watch
  } = useFormContext();
  const [isFocused, setIsFocused] = useState(false);
  const [isInfoOpen, setIsInfoOpen] = useState(false);
  const unitCap = watch('unitCap');
  const unitName = watch('unitName');
  const pricing = watch('pricing');
  useEffect(() => {
    setIsInfoOpen(isFocused && !!unitCap && +unitCap === 0);
  }, [isFocused, unitCap]);
  return /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "unitCap",
    rules: {
      validate: nonNegativeNumberValidation('Set cap (0 or higher)')
    },
    render: renderProps => {
      const _connectControllerToT = connectControllerToTextField(renderProps),
            {
        onBlur: _onBlur
      } = _connectControllerToT,
            rest = _objectWithoutProperties(_connectControllerToT, _excluded);

      return /*#__PURE__*/React.createElement(TextField, _extends({
        isMoney: true,
        alwaysShrinkLabel: true,
        inputProps: positiveQuantityInputProps,
        testid: "sb-cap",
        label: "Preapproved ".concat(pricing === 'unit' ? unitName || 'units' : pricing === 'hour' ? 'hours' : ''),
        onFocus: () => setIsFocused(true),
        onBlur: () => {
          setIsFocused(false);

          _onBlur();
        }
      }, rest, {
        suffix: /*#__PURE__*/React.createElement(InfoIcon, {
          forceOpen: isInfoOpen,
          "data-testid": "sb-cap-info",
          info: /*#__PURE__*/React.createElement("div", {
            "data-testid": "sb-cap-tooltip"
          }, "Payments up to the set amount don't require client approval. If you input 0, or a payment exceeds the set limit, client approval will be required for the payment.")
        })
      }));
    }
  });
}